<!-- .dash-scope: linguagem visual da home (superfície hairline sem sombra, cabeçalho leve,
     tipografia de indicador) — ver o bloco em styles.scss. Escopada aqui pra não vazar. -->
<div class="container-xxl flex-grow-1 container-p-y animate__animated animate__fadeIn dash-scope">
  <!-- Cabeçalho + período. Com cor do grupo vira o cartão de abertura (protótipo, proposta B):
       capa listrada no topo, logo encaixado na borda à esquerda e a saudação ao lado dele. Sem
       cor, fica como antes. -->
  @let brand = groupBrand.identity();
  @let heroLogo = brand?.color && brand?.logoUrl !== failedLogoUrl ? brand?.logoUrl : null;
  <div class="mb-4" [class.home-hero]="!!brand?.color">
    @if (brand?.color) {
      <div class="home-cover"></div>
    }
    <div
      class="home-head d-flex flex-column flex-lg-row justify-content-between gap-3"
      [class.align-items-lg-center]="!brand?.color"
      [class.align-items-lg-end]="!!brand?.color"
    >
      <div class="home-head-main">
        @if (heroLogo) {
          <!-- Imagem decorativa (o nome do grupo já aparece no texto da página). Se o arquivo não
               carrega, o cartão branco some em vez de ficar vazio sobre a capa. -->
          <span class="home-cover-logo" [class.home-cover-logo--icon]="!brand?.logoIsWide">
            <img [src]="heroLogo" alt="" (error)="failedLogoUrl = heroLogo" />
            <!-- Sem logo horizontal, o ícone sozinho deixava o cartão magro: vai o nome do grupo ao lado. -->
            @if (!brand?.logoIsWide) {
              <span class="home-cover-word">{{ brand?.groupName }}</span>
            }
          </span>
        }
        <div class="home-head-text">
          <h4 class="mb-1 fw-bold text-heading">Olá, {{ nomeUsuario }}</h4>
          <!-- Empresa pelo APELIDO + grupo, como no seletor do menu. Antes era a razão social inteira em
               caixa alta ("DIMASA DISTR DE MAQS AUTOMOTORAS SERV E AUTOPECAS LTDA.") no meio da frase;
               ela segue no tooltip. Texto puro: uma pílula com logo aqui competia com o título; o logo
               fica no cartão de abertura, ao lado da frase. -->
          <p class="text-muted mb-0">
            @if (tenantName) {
              Acompanhe a operação de
              <span class="home-tenant" container="body" [ngbTooltip]="tenantLegalName || null">
                <span class="home-tenant-name">{{ tenantName }}</span>@if (tenantGroup) {<span class="home-tenant-group"> · {{ tenantGroup }}</span>}
              </span>
            } @else {
              Selecione uma empresa para ver o resumo da operação.
            }
          </p>
        </div>
      </div>
      <div class="d-flex align-items-end gap-2" [formGroup]="filters">
        @if (hasFreshData && !isLoading) {
          <button type="button" class="btn btn-sm btn-label-info align-self-center mt-auto mb-1"
            (click)="load()">
            <i class="ti ti-sparkles me-1"></i> Carregar novos dados
          </button>
        }
        <div class="position-relative dash-period-field">
          <app-date-range-picker
            formControlName="period"
            [label]="brand?.color ? '' : 'Período'"
            [maxDate]="periodMaxDate"
          ></app-date-range-picker>
          @if (!hasFreshData && lastUpdatedLabel && !isLoading) {
            <!-- Caption do campo (absolute): ancorado no input, não empurra os controles. -->
            <small class="text-muted dash-updated-label">Atualizado {{ lastUpdatedLabel }}</small>
          }
        </div>
        <button
          type="button"
          class="btn btn-icon btn-label-secondary"
          (click)="load()"
          [disabled]="isLoading"
          title="Atualizar"
        >
          @if (isLoading) {
            <span class="spinner-border spinner-border-sm" role="status"></span>
          } @else {
            <i class="ti ti-refresh"></i>
          }
        </button>
      </div>
    </div>
  </div>

  <!-- Skeleton do primeiro load: espelha o layout real (sem layout shift) enquanto o snapshot
       não chega. Recargas posteriores NÃO voltam pro skeleton — o conteúdo fica visível com um
       dim leve (.dash-refreshing), sem travar o usuário. -->
  @if (showSkeleton) {
    <div aria-busy="true">
      <!-- KPIs: o componente REAL com placeholder só nos números — o destino do card não depende
           do snapshot, então o clique funciona desde o primeiro frame (o resto do skeleton é
           inerte de propósito, mas segurar navegação por segundos aqui parecia tela travada). -->
      <app-dashboard-kpi-cards [period]="periodParams" [channelId]="channelId" [loading]="true"></app-dashboard-kpi-cards>

      <!-- O skeleton segue a MESMA ordem da tela carregada (ver o bloco de conteúdo abaixo):
           resultado + faturamento por dia → canais e fluxos → conexões e conferência. Mudou a
           ordem lá, muda aqui. -->
      @if (sectionOn('financeiro') || sectionOn('vendas')) {
      <div class="row g-4 mb-4 dash-row">
        @if (sectionOn('financeiro')) {
          <div class="col-12 col-lg-6">
            <!-- Resultado do período: a cascata (rótulo · barra · valor). -->
            <div class="card h-100 placeholder-glow">
              <div class="card-header">
                <span class="placeholder rounded col-4 d-block mb-2"></span>
                <span class="placeholder rounded col-7 d-block"></span>
              </div>
              <div class="card-body pt-1">
                @for (w of [100, 20, 15, 66]; track $index) {
                  <div class="d-flex align-items-center gap-3 py-2">
                    <span class="placeholder rounded" style="width: 8rem"></span>
                    <span class="flex-grow-1"><span class="placeholder rounded d-block" [style.width.%]="w" style="height: 0.5rem"></span></span>
                    <span class="placeholder rounded" style="width: 6rem"></span>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (sectionOn('vendas')) {
          <div class="col-12 col-lg-6">
            <div class="card h-100 placeholder-glow">
              <div class="card-header">
                <span class="placeholder rounded col-3 d-block mb-2"></span>
                <span class="placeholder rounded col-4 d-block" style="height: 1.75rem"></span>
              </div>
              <div class="card-body pt-0 d-flex align-items-end gap-2" style="height: 210px">
                @for (h of [35, 55, 45, 70, 60, 80, 65, 90, 75, 60, 85, 70]; track $index) {
                  <span class="placeholder rounded flex-grow-1" [style.height.%]="h"></span>
                }
              </div>
            </div>
          </div>
        }
      </div>
      }

      <!-- Seção Vendas: as tabelas por canal (canais e fluxos). -->
      @if (sectionOn('vendas')) {
      @for (i of [1, 2]; track i) {
        <div class="row g-4 mb-4">
          <div class="col-12">
            <!-- Tabela por canal: cabeçalho e três linhas. -->
            <div class="card h-100 placeholder-glow">
              <div class="card-header"><span class="placeholder rounded col-3"></span></div>
              <div class="card-body">
                @for (j of [1, 2, 3, 4]; track j) {
                  <div class="d-flex align-items-center gap-3 py-2">
                    <span class="placeholder rounded col-2"></span>
                    @for (k of [1, 2, 3, 4]; track k) {
                      <span class="placeholder rounded flex-grow-1"></span>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
      }

      <!-- Conexões e conferência -->
      @if (sectionOn('integracoes') || sectionOn('conferencia')) {
      <div class="row g-4 mb-4 dash-row">
        @for (i of [1, 2]; track i) {
          <div class="col-12 col-lg-6">
            <div class="card h-100 placeholder-glow">
              <div class="card-header d-flex justify-content-between">
                <span class="placeholder rounded col-6"></span>
                <span class="placeholder rounded col-3"></span>
              </div>
              <div class="card-body pt-0">
                @for (j of [1, 2, 3]; track j) {
                  <div class="d-flex align-items-center justify-content-between py-2 border-bottom">
                    <div class="flex-grow-1 me-4">
                      <span class="placeholder rounded col-8 d-block mb-1"></span>
                      <span class="placeholder rounded col-5 d-block"></span>
                    </div>
                    <span class="placeholder rounded col-2"></span>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      }
    </div>
  } @else {
    <div [class.dash-refreshing]="refreshing">
      <!-- Empty-state: perfil sem NENHUM indicador de painel (evita um vão em branco). -->
      @if (!hasAnyDashboardWidget) {
        <div class="card border-0 shadow-none">
          <div class="card-body text-center text-muted py-6">
            <i class="ti ti-layout-dashboard d-block mb-3" style="font-size: 3rem; opacity: 0.5"></i>
            <h5 class="mb-1 text-heading">Nenhum indicador disponível</h5>
            <p class="mb-0">Seu perfil não tem acesso aos indicadores do painel. Use o menu lateral para acessar os módulos.</p>
          </div>
        </div>
      }

      <!-- Empresa sem nenhum pedido (spec §12): os primeiros passos entram no lugar do filtro de canal, do
           aviso de período curto e dos widgets. O cartão de abertura fica. -->
      @if (showFirstSteps) {
        <app-dashboard-first-steps [snapshot]="snapshot"></app-dashboard-first-steps>
      } @else {
        <!-- Logo abaixo do cartão de abertura: canal → Pede ação agora (os dois banners de alerta
             viraram itens dele). Sem `channels`/`actions` (API antiga), nada disso renderiza. -->
        <app-dashboard-channel-filter
          [channels]="snapshot?.channels"
          [value]="channelId"
          (valueChange)="onChannelChange($event)"
        ></app-dashboard-channel-filter>

        <app-dashboard-actions
          [actions]="snapshot?.actions"
          [channelId]="channelId"
          [channels]="snapshot?.channels"
          [pendings]="pendings"
          [margin]="result"
          [revenue]="kpis?.revenue"
          [payoutPartial]="result?.partial ?? 0"
          [period]="periodParams"
        ></app-dashboard-actions>

        <!-- Aviso de período curto: uma linha discreta colada nos indicadores que ele explica (sem
             banner nem fundo). -->
        @if (shortPeriodDate; as firstDay) {
          <p class="text-muted small mb-2" data-short-period role="status">
            <i class="ti ti-info-circle me-1" aria-hidden="true"></i>{{ channelId !== null ? 'Vendas deste canal' : 'Vendas' }} desde {{ firstDay }}, sem comparação com o período anterior.
          </p>
        }

        <!-- ORDEM DA TELA (spec "Comportamento"): cartão de abertura → filtro de canal → Pede ação agora →
             aviso de período curto → indicadores → Resultado + Faturamento por dia → Canais → Fluxo dos
             pedidos → Fluxo das notas fiscais → Conexões + Conferência. O que fica acima da barra
             "Exibir:" é sempre visível. -->
        <app-dashboard-kpi-cards
          [kpis]="kpis"
          [summary]="result"
          [channels]="snapshot?.channels"
          [channelId]="channelId"
          [period]="periodParams"
          [noComparison]="shortPeriodDate !== null"
        ></app-dashboard-kpi-cards>

        <!-- Home enxuta: o essencial (alertas, KPIs, erros de ERP) fica sempre visível; cada botão
             liga/desliga uma seção da operação (1 toque). Escolha persiste por navegador
             (mc-dash-sections). Desktop = chips inline; mobile = grid uniforme 2 colunas (CSS). -->
        @if (visibleSectionDefs.length) {
          <div class="align-items-center gap-2 mb-4 dash-section-bar">
            <small class="text-muted me-1 flex-shrink-0">Exibir:</small>
            @for (s of visibleSectionDefs; track s.id) {
              <button
                type="button"
                class="btn btn-sm rounded-pill"
                [class.btn-primary]="sectionOn(s.id)"
                [class.btn-label-secondary]="!sectionOn(s.id)"
                [attr.aria-pressed]="sectionOn(s.id)"
                (click)="toggleSection(s.id)"
              >
                <i class="ti {{ s.icon }} me-1"></i>{{ s.label }}
              </button>
            }
          </div>
        }

        <!-- Resultado (Financeiro) e Faturamento por dia (Vendas) dividem a linha; dash-row absorve o que
             faltar por seção fechada ou permissão. -->
        @if (sectionOn('financeiro') || sectionOn('vendas')) {
          <div class="row g-4 mb-4 dash-row">
            @if (sectionOn('financeiro')) {
              <app-dashboard-result *appHasPermission="roles.ORDER" [result]="result" [revenue]="kpis?.revenue" [channelId]="channelId" [period]="periodParams"></app-dashboard-result>
            }
            @if (sectionOn('vendas')) {
              <!-- Todo número do card é dado de nota (a API zera sem `invoice`): sem a permissão, o card
                   mostraria R$ 0,00 como se fosse real. -->
              <app-dashboard-revenue-chart *appHasPermission="roles.INVOICE" [snapshot]="snapshot" [kpis]="kpis" [channelId]="channelId" [noComparison]="shortPeriodDate !== null" [period]="periodParams"></app-dashboard-revenue-chart>
            }
          </div>
        }

        <!-- Seção Vendas: canais e os fluxos (uma linha por canal). As tabelas só existem com a API nova
             (channelTable/orderFlow/invoiceFlow). -->
        @if (sectionOn('vendas')) {
          @if (snapshot?.channelTable) {
            <div class="row g-4 mb-4 dash-row" *appHasPermission="[roles.ORDER, roles.INVOICE]">
              <app-dashboard-channels [rows]="snapshot?.channelTable" [channels]="snapshot?.channels" [summary]="result"
                [period]="periodParams" (widenPeriod)="widenPeriod()"></app-dashboard-channels>
            </div>
          }

          @if (snapshot?.orderFlow) {
            <div class="row g-4 mb-4 dash-row" *appHasPermission="roles.ORDER">
              <app-dashboard-order-flow [rows]="snapshot?.orderFlow" [channels]="snapshot?.channels" [erp]="snapshot?.erp"
                [summary]="result" [period]="periodParams" (widenPeriod)="widenPeriod()"></app-dashboard-order-flow>
            </div>
          }

          @if (snapshot?.invoiceFlow) {
            <div class="row g-4 mb-4 dash-row" *appHasPermission="roles.INVOICE">
              <app-dashboard-invoice-flow [rows]="snapshot?.invoiceFlow" [channels]="snapshot?.channels" [erp]="snapshot?.erp"
                [period]="periodParams" (widenPeriod)="widenPeriod()"></app-dashboard-invoice-flow>
            </div>
          }
        }

        <!-- Conexões (Integrações) e Conferência dividem a última linha. -->
        @if (sectionOn('integracoes') || sectionOn('conferencia')) {
          <div class="row g-4 mb-4 dash-row">
            @if (sectionOn('integracoes')) {
              <app-dashboard-connections *appHasPermission="roles.INTEGRATION" [channels]="snapshot?.channels"
                [integrations]="snapshot?.integrations" [catalogData]="snapshot?.catalog"></app-dashboard-connections>
            }
            @if (sectionOn('conferencia')) {
              <app-dashboard-conference *appHasPermission="roles.SALE_CONFERENCE_RANKING" [checkers]="conferenceCheckers"></app-dashboard-conference>
            }
          </div>
        }
      }
    </div>
  }
</div>
